module.exports = __webpack_public_path__ + "img/social-media-pro.bce6c9f.svg";